module.exports = __webpack_public_path__ + "img/teamwork.b0dca153.png";